import React from "react"
import { connect } from 'react-redux'
import { Flex } from 'reflexbox'
import { compose } from 'recompose'
import CSSModules from 'helpers/CSSModulesUtil'
import { Checkbox } from 'react-toolbox/lib/checkbox'
import Pie from 'components/custom/Highcharts/Pie'
import Body2 from 'components/typography/body2/index'
import FulcrumDivider from 'components/fulcrum/divider/Divider'
import AeResourcesTable from "./AeResourcesTable"

import {
  updateAeResourcesQueryAction
} from '../actions'
import {
  segmentsEnum, chartsEnum
} from '../constants'
import {
  aeResourcesQuerySelector,
} from '../selectors'
import styles from '../styles.scss'

const mapStateToProps = (state) => {
  return {
    aeResourcesQuery: aeResourcesQuerySelector(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateAeResourcesQuery: (segments) => dispatch(updateAeResourcesQueryAction(segments)),
  }
}

class AeResourcesChart extends React.Component {
  renderChart(report, segment) {
    return (
      <div styleName='aeSegmentContainer'>
        <Body2 theme={styles}>{segment}</Body2>
        <div styleName='aeSegmentChartContainer'>
          <div styleName='rowCharts'>
            {report.charts.length > 0 ?
              report.charts.map((chart, index) =>
                <div styleName='regionChart' key={index}> 
                  <Pie
                    title={report.title}
                    data={chart.data}
                    additionalOptions={
                      {
                        plotOptions: {
                          pie: {
                            colors: ['#76b900', "#800000", "#CD5C5C", "#B22222", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                            dataLabels: {
                              enabled: true,
                              format: '<b>{point.name}</b>: {point.y}%'
                            }
                          }
                        },
                        subtitle: {
                          text: chart.region
                        }
                      }
                    }
                  />
                </div>
              ) :
              <div styleName='regionChart'>
                <Pie
                  title={report.title}
                  data={[]}
                />
              </div>}
          </div>
          {report.tableCategories.length > 1 &&
            <AeResourcesTable
              tableData={report.tableData}
              categories={report.tableCategories}
            />}
        </div>
      </div>
    )
  }

  renderCharts(reports) {
    const segments = this.props.aeResourcesQuery
    return segments.map((segment, index) => {
      const report = reports.find(report => report.segment == segment)
      return (
        <React.Fragment key={index}>
          {report && this.renderChart(report, segment)}
          {segments.length - 1 != index && <FulcrumDivider styleName='divider' />}
        </React.Fragment>
      )
    })
  }

  render() {
    const {
      report,
      aeResourcesQuery,
      updateAeResourcesQuery
    } = this.props

    const handleChange = (field, isChecked) => {
      let newQuery = [...aeResourcesQuery]
      if (isChecked) {
        newQuery.push(field)
      } else {
        const index = newQuery.findIndex(segment => segment === field)
        newQuery.splice(index, 1)
      }
      updateAeResourcesQuery(newQuery)
    }

    return (
      <div>
        <Flex row='true' wrap>
          {Object.values(segmentsEnum).map((segment) => (
            <Checkbox
              styleName='checkboxes'
              key={segment.value}
              label={segment.label}
              checked={aeResourcesQuery.includes(segment.value)}
              onChange={handleChange.bind(this, segment.value)}
            />
          ))}
        </Flex>
        <FulcrumDivider styleName='divider' />
        <div>
          {this.renderCharts(report)}
        </div>
      </div>
    );
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withStyle = CSSModules(styles)

export default compose(
  withConnect,
  withStyle
)(AeResourcesChart)
